"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _FileInput = _interopRequireDefault(require("./FileInput"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FilePicker =
/*#__PURE__*/
function (_React$Component) {
  _inherits(FilePicker, _React$Component);

  function FilePicker() {
    var _ref;

    var _temp, _this;

    _classCallCheck(this, FilePicker);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (_temp = _this = _possibleConstructorReturn(this, (_ref = FilePicker.__proto__ || Object.getPrototypeOf(FilePicker)).call.apply(_ref, [this].concat(args))), _this._validate = function (files) {
      var _this$props = _this.props,
          onError = _this$props.onError,
          onChange = _this$props.onChange,
          maxSize = _this$props.maxSize,
          extensions = _this$props.extensions; // make sure a file was provided in the first place

      if (!files || files.length === 0) {
        onError('Failed to upload a file.');
        return;
      } // if we care about file extensions


      if (extensions) {
        // the extensions we care about
        var exts = extensions.map(function (ext) {
          return ext.toLowerCase();
        });
        var isValid = files // pull the extension out of each name of the file
        .map(function (file) {
          return file.name.split('.').pop().toLowerCase();
        }) // make sure each extension satisfies the required list
        .reduce(function (prev, extension) {
          return prev && exts.includes(extension);
        }, true); // if one of the files are invalid

        if (!isValid) {
          // yell loudly
          onError("Must upload a file of type: ".concat(extensions.join(' or ')));
          return;
        }
      } // convert maxSize from megabytes to bytes


      var maxBytes = maxSize * 1000000; // look to see if any files are above the limit

      var tooBig = files.reduce(function (prev, file) {
        return prev || file.size > maxBytes;
      }, false);

      if (tooBig) {
        onError("File size must be less than ".concat(maxSize, " MB."));
        return;
      } // return native file object


      onChange(files);
    }, _this.render = function () {
      return React.createElement(_FileInput.default, {
        onChange: _this._validate,
        style: _this.props.style
      }, _this.props.children);
    }, _temp));
  }

  return FilePicker;
}(React.Component);

FilePicker.defaultProps = {
  maxSize: 2
};
var _default = FilePicker;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/quark-web/components/form/FilePicker/index.js
// module id = ./node_modules/quark-web/components/form/FilePicker/index.js
// module chunks = 0